
export const parseFlightNumber = (input: string): { carrierCode: string; flightNumber: string } => {
  if (!input) {
    console.error('Error parsing flight number: Input is empty or undefined');
    return { carrierCode: 'XX', flightNumber: '0000' };
  }
  
  console.debug(`🔍 DEBUG - Parsing flight number: "${input}"`);
  
  // Remove any whitespace
  const cleanInput = input.replace(/\s+/g, '');
  
  // Try to extract the carrier code (usually 2 letters) and flight number
  // Most airline codes are 2 letters, but some (like IB) might use numbers too
  const match = cleanInput.match(/^([A-Z0-9]{2})(\d+)$/i);
  
  if (match) {
    console.debug(`🔍 DEBUG - Successfully parsed "${input}" into:`, { 
      carrierCode: match[1].toUpperCase(), 
      flightNumber: match[2].trim() 
    });
    return { 
      carrierCode: match[1].toUpperCase(), 
      flightNumber: match[2].trim() 
    };
  }
  
  // Fallback method - assume first 2 characters are carrier code, rest is flight number
  const carrierCode = cleanInput.substring(0, 2);
  const flightNumber = cleanInput.substring(2).trim();
  
  console.debug(`🔍 DEBUG - Fallback parsing for "${input}":`, { 
    carrierCode: carrierCode.toUpperCase(), 
    flightNumber 
  });
  
  return { 
    carrierCode: carrierCode.toUpperCase(), 
    flightNumber 
  };
};
